<template>
  <div>
    <form>
      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="0"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      expertne_posudenie: "0",
      skore: 0
    },

    craItem: {},

    selects: {
      expertne_posudenie: ["nehodnotené", "malá", "stredná", "vysoká"]
    },

    manual: {
      expertne_posudenie: {
        nazov:
          "Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia",
        zdroj: [],
        poznamka: [],
        priklad: [],
        charakteristika: [
          "Expertné posúdenie znamená komplexné hodnotenie, ktoré je založené na teoretických znalostiach a praktických skúsenostiach hodnotiteľa – poskytuje odpoveď na otázku „Aká je z Vášho profesionálneho pohľadu na odsúdeného pravdepodobnosť jeho opakovaného zlyhania (trestnej činnosti) v najbližších dvoch rokoch?“"
        ]
      }
    }
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    }
  },

  created() {
    this.getSocialnyKurator();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },
    clear() {
      this.form.expertne_posudenie = "nehodnotené";
      this.skore = 0;
    },
    getSocialnyKurator() {
      apiService.getSocialnyKurator(this.$route.params.id).then(response => {
        this.form = response;
      });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService.updateSocialnyKurator(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    openItem() {
      apiService
        .updateSocialnyKurator(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updateSocialnyKurator(this.form, this.$route.params.id)
              .then(
                response => {
                  this.snackbar_saved = true;
                  this.form = response;
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>